<template>
  <site-footer>
    <div class="flex w-full py-2">
      <div class="w-1/2 flex justify-end border-r border-gray-300 px-4">
        <button class="btn-bare text-base" @click="goToPrivacyPolicy">
          {{ $t("Legal.privacyPolicy") }}
        </button>
      </div>
      <div class="w-1/2 flex justify-start px-4">
        <button class="btn-bare text-base" @click="toggleContactLegalModal">
          {{ $t("Legal.contactAndLegalInfoLink") }}
        </button>
        <contact-legal-modal
          :show="showContactLegalModal"
          @close="toggleContactLegalModal"
        />
      </div>
    </div>
  </site-footer>
</template>

<script>
import SiteFooter from "@/components/application/SiteFooter.vue";
import ContactLegalModal from "@/components/legal/ContactLegalModal.vue";

export default {
  components: { SiteFooter, ContactLegalModal },
  data() {
    return {
      showContactLegalModal: false,
    };
  },
  methods: {
    goToPrivacyPolicy() {
      this.$router.push({ name: "privacy-policy" });
    },
    toggleContactLegalModal() {
      this.showContactLegalModal = !this.showContactLegalModal;
    },
  },
};
</script>
